<template>
    <ul class="filter clearfix">
        <li v-for="(label, id) in visibleTabs"><a href="#" @click.prevent="setCurrent(id)" :class="{ active: (current === id) }">{{ label }}</a></li>
    </ul>
</template>

<script>
    import { mapGetters } from 'vuex'
    const publicTabs = ['created_at', 'likes', 'downloads'];


    export default {
        props: { 'current': {
                type: String,
                default: 'created_at'
            }},

        data() {
            return {
                tabs: {
                    'created_at': 'Jaunākie',
                    'likes': 'Visvairāk patīk',
                    'downloads': 'Lejuplādētākie',
                }
            }
        },

        methods: {
            setCurrent(val) {
                this.$emit('update:current', val)
            },
        },

        computed: {

            ...mapGetters(['isAuthenticated']),

            visibleTabs: function () {
                if (this.isAuthenticated) {
                    // Return all tabs
                    return this.tabs;
                } else {
                    // Return only public tabs
                    return Object.keys(this.tabs).filter(key => publicTabs.includes(key))
                        .reduce((obj, key) => {
                            obj[key] = this.tabs[key];
                            return obj;
                        }, {});
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "../../sass/settings";

    .filter {
        list-style: none;
        display: block;
        margin: 0;

        li {
            display: inline-block;

            > a {
                display: inline-block;
                padding: (20px/18px + em) (10px/18px + em);
                color: #999999;
                font-weight: 700;
                font-size: 18px;
                line-height: 1;
                transition: color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

                &:hover,
                &:active,
                &.active {
                    color: #404141;
                    box-shadow: inset 0 -3px 0 $color-green;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/MyMaterialFilter.vue